import { TextBase, Tooltip, entityIcons } from '@carboncopyco/ui';
import classNames from 'classnames';
import { type ChangeEventHandler, useRef } from 'react';

type TopAssetsTypeFilterOptionProps = {
  checked: boolean;
  onChange: ChangeEventHandler<HTMLInputElement>;
  item: any;
  disabled?: boolean;
};
export const TopAssetsTypeFilterOption = ({
  checked,
  onChange,
  item,
  disabled,
}: TopAssetsTypeFilterOptionProps) => {
  const anchorRef = useRef<HTMLDivElement>();

  return (
    <div
      ref={anchorRef}
      className="group focus:outline-none"
    >
      <div
        className={classNames(
          'px-2 h-9 cursor-pointer flex items-center w-full gap-2 group-focus:bg-ds-natural-50 group-focus:rounded-md',
          { 'opacity-50 pointer-events-none': disabled }
        )}
      >
        <div className="flex items-center gap-3">
          <input
            disabled={disabled}
            checked={checked}
            onChange={onChange}
            type="checkbox"
            className={classNames(
              'rounded-sm border outline-none active:outline-none active:ring-0 active:ring-offset-0 focus:outline-none focus:ring-0 focus:ring-offset-0',
              checked
                ? 'hover:text-ds-primary-400 text-ds-primary active:text-ds-primary-500 cursor-pointer'
                : 'cursor-pointer text-ds-primary border-ds-natural-200',
              {
                'hover:border-ds-primary-400 active:border-ds-primary-500':
                  !disabled,
              }
            )}
          />
          <div className="flex items-center gap-2">
            {entityIcons[item.id]}
            <TextBase
              color="text-ds-natural-600"
              label={item.label}
              ellipsis
            />
          </div>
        </div>
        {disabled && (
          <Tooltip
            placement="right"
            anchorRef={anchorRef}
            noArrow
          >
            <div className="p-3">{`There aren't any ${item.label.toLowerCase()} to show here, so this option is disabled`}</div>
          </Tooltip>
        )}
      </div>
    </div>
  );
};
